module.exports = __webpack_public_path__ + "img/iconweiruzhi.afc92338.png";